export const OpenModeLogin = {
    ForgotPassword: 1,
    SignUp: 2
}